// extracted by mini-css-extract-plugin
export default {"attachments":"UploadedItem_attachments__+fxcb","attachmentItems":"UploadedItem_attachmentItems__DVHP7"};